import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {

  constructor(private productService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  values:any
  count=0;
  output:any=[];
  brand:any=[];

  baseUrl=this.productService.ReturnBase();
  brandUrl=this.baseUrl+'viewBrands/brand_dropdown';
  getUrl=this.baseUrl+'viewProducts';
  brabdDetailUrl=this.baseUrl+'viewProducts?product_brand_id=';
  searchUrl=this.baseUrl+'viewProducts?product_name=';
  /*
  brandUrl='http://192.241.151.66:5000/viewBrands/brand_dropdown';
  getUrl='http://192.241.151.66:5000/viewProducts';
  brabdDetailUrl='http://192.241.151.66:5000/viewProducts?product_brand_id=';
  searchUrl='http://192.241.151.66:5000/viewProducts?product_name=';
  */
  search:string='';
  product:any=[];
 isShownProduct=false;
 PagingFlag=0
//-------------function for search--------------------
Search(){
  this.count=0
  console.log("product search",this.search);
  console.log("click search",this.search);
  if(this.search!='')
  {
  this.isShownProduct=true;
  this.productService.getData(this.searchUrl+this.search).subscribe((res)=>{
  this.output=res.data
  })
  //this.PagingFlag=1
}
else{
   //-------api get()calling-------------
   this.productService.getData(this.getUrl).subscribe((res)=>{
   this.output=res.data

  })
}
}

//------function for routing-------------------------

productDetails(){
  this.router.navigateByUrl(('admin/product-details'));  
}
//--------function which give name of selected item---------
getValue = (item : string) =>{
   
  this.productService.setProductId(item)
  document.body.scrollTop = document.documentElement.scrollTop = 0;

}
//------routing to edit page--------------------
    
EditProducts(){
  this.router.navigateByUrl(('admin/edit-product'));  
  console.log("call edit product")
}

//function for going to next page
  clicks_next(){
   
    this.count=this.count+1;
    //if(this.selectedTeam !='All' && this.PagingFlag==0)
    if(this.selectedTeam !='All' && this.search=="")
    {
      //-------api get()calling for deptmt wise details-------------
     this.productService.getData(this.brabdDetailUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      console.log("Employee details =",this.output)
        })
    }
   // else if(this.selectedTeam =='All' && this.PagingFlag==1)
   else if(this.selectedTeam =='All' && this.search!=""){

      this.productService.getData(this.searchUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
        })

    }
   // else if(this.selectedTeam !='All' && this.PagingFlag==1)
   else if(this.selectedTeam !='All' && this.search!=""){
       this.productService.getData(this.searchUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
        })

    }
    else{
    
    //-------api get()calling for next page-------------
    this.productService.getData(this.getUrl+'?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  }
  }
  
  //function for going to previous page
  clicks_previous(){
    this.count=this.count-1;
    if(this.count<0)
    {
      this.count=0
    }
    //if(this.selectedTeam !='All' && this.PagingFlag==0)
    if(this.selectedTeam !='All' && this.search==""){
      //-------api get()calling for deptmt wise details-------------
     this.productService.getData(this.brabdDetailUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      console.log("Employee details =",this.output)
        })
    }
    //else if(this.selectedTeam =='All' && this.PagingFlag==1)
    else if(this.selectedTeam =='All' && this.search!=""){

      this.productService.getData(this.searchUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
        })

    }
    //else if(this.selectedTeam !='All' && this.PagingFlag==1)
    else if(this.selectedTeam !='All' && this.search!=""){
       this.productService.getData(this.searchUrl+this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
        })

    }
    else{
    //-------api get()calling for previous page-------------
    this.productService.getData(this.getUrl+'?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data

    })
  }
  }

//---------for select a particular brand----------
selectedTeam = '';
onSelected(value:string): void {
  this.selectedTeam = value;
  console.log("select brand=",this.selectedTeam);

   //-------api get()calling-------------
   if(this.selectedTeam !='All')
   {
    this.count=0
   this.productService.getData(this.brabdDetailUrl+this.selectedTeam+'&offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
  })
}
else{

    this.productService.getData(this.getUrl).subscribe((res)=>{
    this.output=res.data
  })
}

}

  ngOnInit(): void {
      this.productService.getData(this.getUrl).subscribe((res)=>{
      this.output=res.data
      console.log("message=",this.output)

    })
   //-------api for get brand name---------

   this.productService.getData(this.brandUrl).subscribe((res)=>{
   this.brand=res.data
  })
  
  }

}
